import modalSocialSubscriptionErrorTemplate from '../../view/angular/common/modal/modal-social-subscription-error.tpl.html';

angular
  .module('jrRegistration', [
    'jrConfig',
    'jrAutocompleteEmail',
    'jrUtil',
    'jrEvents',
    'jrCommonService',
    'jrTracking',
  ])
  .value('modalSocialSubscriptionErrorTemplate', modalSocialSubscriptionErrorTemplate)
  .controller('RegistrationCtrl', RegistrationCtrl);

RegistrationCtrl.$inject = [
  'JobseekerConfig',
  'Messages',
  'AutocompleteEmailConfig',
  'SearchDistanceConfig',
  'SocialLoginConfig',
  'SubscriptionService',
  'ModalProposalService',
  'EventsService',
  'GoogleTagManagerTrackingService',
  'SearchFormService',
  '$timeout',
  '$scope',
  'SearchConfig',
  'PasswordService',
  'MyProfileService',
  'MyProfileConfig',
  '$rootScope',
  '$window',
  'modalSocialSubscriptionErrorTemplate',
];

function RegistrationCtrl(
  JobseekerConfig,
  Messages,
  AutocompleteEmailConfig,
  SearchDistanceConfig,
  SocialLoginConfig,
  SubscriptionService,
  ModalProposalService,
  EventsService,
  GoogleTagManagerTrackingService,
  SearchFormService,
  $timeout,
  $scope,
  SearchConfig,
  PasswordService,
  MyProfileService,
  MyProfileConfig,
  $rootScope,
  $window,
  modalSocialSubscriptionErrorTemplate
) {
  $scope.messages = Messages;
  $scope.autocompleteEnabled = AutocompleteEmailConfig.enabled;
  $scope.distanceFilterEnabled = SearchDistanceConfig.enabled;
  $scope.socialLoginEnabled = SocialLoginConfig.enabled;
  $scope.search = SearchFormService.search;
  $scope.isEmptySearch = !$scope.search.what && !$scope.search.where;
  $scope.hasBeenSubmitted = false;
  $scope.jobseekerRegistered = false;
  $scope.resendMail = false;
  $scope.existingJobseeker = false;
  $scope.loginError = false;
  $scope.sendEmailError = false;
  $scope.recoverSuccess = false;
  $scope.setPasswordSuccess = false;
  $scope.redirectUrl = '';
  $scope.registrationConfirmed = JobseekerConfig.registrationConfirmed;
  $scope.isSubscriptionCaptchaEnabled = SearchConfig.isSubscriptionCaptchaEnabled;
  $scope.resetError = false;
  $scope.isMobile = jrConfigGlobal.isMobile;
  $scope.profileConfig = MyProfileConfig;
  $scope.mySearches = [
    {
      what: $scope.search.what,
      where: $scope.search.where,
    },
    {
      what: undefined,
      where: undefined,
    },
    {
      what: undefined,
      where: undefined,
    },
  ];

  $scope.jobseeker = JobseekerConfig.isLogged ? JobseekerConfig : {};
  $scope.forms = {};

  $scope.loading = true;

  if ($scope.isSubscriptionCaptchaEnabled) {
    $scope.registrationCaptcha = setTimeout(function () {
      grecaptcha.render('registration-captcha-container', {
        sitekey: jrConfigGlobal.captcha.siteKey,
      });
    }, 2000);
  }

  $scope.inputType = 'password';
  $scope.hideShowPassword = function () {
    $scope.inputType = PasswordService.hideShowPassword($scope.inputType);
  };

  $scope.clearError = function () {
    $scope.changePasswordError = false;
  };

  function afterRegistration(result) {
    const statusCreated = result.status === 201;
    const userExist = result.status === 406;
    const statusConflict = result.status === 409;

    $scope.loading = false;
    if (userExist) {
      $scope.existingJobseeker = true;
    }
    if (statusCreated || statusConflict) {
      // Emitting the subscription sent event
      EventsService.emit.subscriptionSent({
        type: 'modal',
        email: $scope.jobseeker.email,
      });

      GoogleTagManagerTrackingService.trackSignup($scope.jobseeker.email);

      $scope.jobseekerRegistered = true;
      $scope.existingJobseeker = false;
    }
  }

  function afterSocialRegistration(result) {
    const statusCreated = result.status === 201;
    const statusConflict = result.status === 409;

    $scope.loading = false;
    if (statusCreated || statusConflict) {
      $window.location.href = result.headers('activateUrl');
    }
  }

  function afterLogin(result) {
    const loginError = result.status === 406;

    $scope.loading = false;
    if (loginError) {
      $scope.jobseekerLogged = false;
      $scope.loginError = true;
    } else {
      GoogleTagManagerTrackingService.trackLogin();
      $scope.jobseekerLogged = true;
      $scope.loginError = false;
      $window.location.href = result.headers('x-redirectAfterLogin') || document.referrer;
    }
  }

  function afterRecovery(result) {
    const sendEmailError = result.status === 503;

    $scope.loading = false;
    if (sendEmailError) {
      $scope.sendEmailError = true;
      $scope.recoverSuccess = false;
    } else {
      GoogleTagManagerTrackingService.trackRecoverPassword();
      $scope.sendEmailError = false;
      $scope.recoverSuccess = true;
    }
  }

  function afterReset(result) {
    $scope.loading = false;
    if (result.status === 400 || result.status === 500) {
      $scope.resetError = true;
    } else {
      GoogleTagManagerTrackingService.trackResetPassword();
      $scope.redirectUrl = result.headers('x-redirectAfterLogin');
    }
  }

  function afterChangePassword(result) {
    $scope.loading = false;
    if (result.status === 403) {
      $scope.changePasswordError = true;
    } else {
      GoogleTagManagerTrackingService.trackChangePassword();
      $scope.redirectUrl = result.headers('X-Redirect-Url');
    }
  }

  $scope.$watchCollection('search', function (newValue) {
    $scope.mySearches[0] = {
      what: newValue.what,
      where: newValue.where,
    };
    if (typeof $scope.forms.registration !== 'undefined' && !JobseekerConfig.isLogged) {
      $scope.forms.registration.$setValidity('searchParams', !!newValue.what || !!newValue.where);
    }
  });

  $scope.submitRegistration = function (e) {
    $scope.hasBeenSubmitted = true;
    let captchaUserResponse;

    if (typeof $scope.forms.registration !== 'undefined' && !JobseekerConfig.isLogged) {
      $scope.forms.registration.$setValidity(
        'searchParams',
        !!$scope.search.what || !!$scope.search.where
      );
    }

    if (SearchConfig.isSubscriptionCaptchaEnabled) {
      captchaUserResponse = grecaptcha.getResponse();
      $scope.captchaUserResponseOk =
        captchaUserResponse !== undefined && captchaUserResponse.length !== 0;
      if (!$scope.captchaUserResponseOk) {
        grecaptcha.reset();
        return;
      }
    }

    if (!$scope.forms.registration.$valid) {
      return;
    }
    $scope.loading = true;

    const userData = {
      email: $scope.jobseeker.email,
      search: $scope.search,
      password: $scope.forms.registration.password.$viewValue,
      firstname: $scope.forms.registration.firstname
        ? $scope.forms.registration.firstname.$viewValue
        : '',
      lastname: $scope.forms.registration.lastname
        ? $scope.forms.registration.lastname.$viewValue
        : '',
    };

    // Subscribing
    SubscriptionService.subscribe(
      userData.email,
      userData.search,
      '',
      userData.password,
      '',
      '',
      userData.firstname,
      userData.lastname,
      captchaUserResponse
    ).then(afterRegistration, afterRegistration);
    e.preventDefault();
  };

  $scope.submitSocialRegistration = function (e, source, isLogin) {
    if (!isLogin) {
      $scope.hasBeenSubmitted = true;
      $scope.isSocialLogin = true;
      if (typeof $scope.forms.registration !== 'undefined' && !JobseekerConfig.isLogged) {
        $scope.forms.registration.$setValidity(
          'searchParams',
          !!$scope.search.what || !!$scope.search.where
        );
      }
      if ($scope.forms.registration.$error.searchParams) {
        return;
      }
    }

    if (source === 'facebook') {
      FB.login(
        function (response) {
          if (response.status === 'connected') {
            if (isLogin) {
              GoogleTagManagerTrackingService.trackFacebookLogin();
            }
            FB.api(
              '/me',
              {
                fields: 'last_name, first_name, email',
              },
              function (response) {
                if (typeof response.email === 'undefined') {
                  // Error
                  ModalProposalService.openModal(
                    angular.extend(
                      {
                        template: modalSocialSubscriptionErrorTemplate,
                        scope: $scope,
                      },
                      {}
                    )
                  );
                } else {
                  $scope.jobseeker.email = response.email;
                  $scope.jobseeker.firstName = response.first_name;
                  $scope.jobseeker.lastName = response.last_name;
                  // Subscribing
                  SubscriptionService.subscribe(
                    $scope.jobseeker.email,
                    $scope.search,
                    'facebook',
                    '',
                    '',
                    'page',
                    $scope.jobseeker.firstName,
                    $scope.jobseeker.lastName
                  ).then(afterSocialRegistration, afterSocialRegistration);
                }
              }
            );
          }
        },
        {
          scope: 'public_profile, email',
          auth_type: 'rerequest',
        }
      );
    } else if (source === 'google') {
      auth2
        .signIn({
          scope: 'profile email',
        })
        .then(function (googleUser) {
          if (isLogin) {
            GoogleTagManagerTrackingService.trackGoogleLogin();
          }
          const userProfile = googleUser.getBasicProfile();
          $scope.jobseeker.email = userProfile.getEmail();
          $scope.jobseeker.firstName = userProfile.getGivenName();
          $scope.jobseeker.lastName = userProfile.getFamilyName();
          // Subscribing
          SubscriptionService.subscribe(
            $scope.jobseeker.email,
            $scope.search,
            'google',
            '',
            '',
            'page',
            $scope.jobseeker.firstName,
            $scope.jobseeker.lastName
          ).then(afterSocialRegistration, afterSocialRegistration);
        });
    } else if (source === 'linkedin') {
      IN.User.authorize(function () {
        if (IN.User.isAuthorized()) {
          IN.API.Profile('me')
            .fields([
              'firstName',
              'lastName',
              'industry',
              'location:(name)',
              'picture-url',
              'email-address',
              'educations',
              'date-of-birth',
            ])
            .result(function (profile) {
              if (isLogin) {
                GoogleTagManagerTrackingService.trackLinkedinLogin();
              }
              const userProfile = profile.values[0];
              $scope.jobseeker.email = userProfile.emailAddress;
              $scope.jobseeker.firstName = userProfile.firstName;
              $scope.jobseeker.lastName = userProfile.lastName;
              // Subscribing
              SubscriptionService.subscribe(
                $scope.jobseeker.email,
                $scope.search,
                'linkedin',
                '',
                '',
                '',
                $scope.jobseeker.firstName,
                $scope.jobseeker.lastName
              ).then(afterSocialRegistration, afterSocialRegistration);
            });
        }
      });
    }

    e.preventDefault();
  };

  $scope.recoverPassword = function (e) {
    $scope.hasBeenSubmitted = true;
    if (!$scope.forms.recovery.$valid) {
      return;
    }
    $scope.loading = true;
    // Subscribing
    SubscriptionService.recoverPassword($scope.jobseeker.email).then(afterRecovery, afterRecovery);

    e.preventDefault();
  };

  $scope.updateProfile = function (e, modalDismiss, hasOnlyPassword) {
    $scope.hasBeenSubmitted = true;
    if (!$scope.forms.setPassword.$valid) {
      return;
    }
    $scope.loading = true;

    const profile = {
      password: $scope.jobseeker.password || '',
      'confirm-password': $scope.jobseeker.password || '',
      'old-password': 'old_password',
    };

    if (!hasOnlyPassword) {
      profile.firstname = $scope.jobseeker.firstName || '';
      profile.lastname = $scope.jobseeker.lastName || '';
    }

    MyProfileService.updateProfile(profile).then(updateSuccessful, updateFailed);

    function updateSuccessful() {
      $scope.loading = false;
      $scope.updateProfileDone = true;
      GoogleTagManagerTrackingService.tracksetPassword();
      $rootScope.jobseekerFirstname = $scope.jobseeker.firstName || $scope.profileConfig.firstname;
      $rootScope.jobseekerLastname = $scope.jobseeker.lastName || $scope.profileConfig.lastname;

      jtag('event', 'click_confirmation_popup', {
        event_label: 'add_password',
      });

      modalDismiss();
    }

    function updateFailed(error) {
      $scope.loading = false;
      $scope.resetError = true;
    }
    e.preventDefault();
  };

  $scope.resetPassword = function (e) {
    $scope.hasBeenSubmitted = true;
    if (!$scope.forms.reset.$valid) {
      return;
    }
    $scope.loading = true;
    // Subscribing
    SubscriptionService.resetPassword(
      $scope.forms.reset.password.$viewValue,
      $scope.forms.reset.confirmPassword.$viewValue
    ).then(afterReset, afterReset);

    e.preventDefault();
  };

  $scope.changePassword = function (e) {
    $scope.hasBeenSubmitted = true;
    if (!$scope.forms.change.$valid) {
      return;
    }
    $scope.loading = true;
    // Subscribing
    SubscriptionService.changePassword(
      $scope.forms.change.password.$viewValue,
      $scope.forms.change.confirmPassword.$viewValue,
      $scope.forms.change.oldPassword.$viewValue
    ).then(afterChangePassword, afterChangePassword);

    e.preventDefault();
  };

  $scope.redirectTo = function (url) {
    document.location.href = url;
  };

  $scope.submitLogin = function (e) {
    $scope.hasBeenSubmitted = true;
    if (!$scope.forms.login.$valid) {
      return;
    }
    $scope.loading = true;
    // Login
    SubscriptionService.login(
      $scope.forms.login.email.$viewValue,
      $scope.forms.login['login-password'].$viewValue
    ).then(afterLogin, afterLogin);
    e.preventDefault();
  };

  $scope.reset = function () {
    $scope.resendMail = true;
  };

  $scope.resetLoginError = function () {
    $scope.loginError = false;
  };

  $timeout(function () {
    $scope.loading = false;
  });

  $scope.infoPath = jrConfigGlobal.infoPath;
  $scope.socialLogin = jrConfigGlobal.socialLogin.enabled;
}
